<script setup>
import { LABEL_COLOR_OPTIONS } from 'dashboard/helper/labelColor';

defineProps({
  modelValue: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <div class="flex flex-wrap gap-1">
    <button
      v-for="option in LABEL_COLOR_OPTIONS"
      :key="option"
      type="button"
      role="radio"
      :aria-checked="modelValue === option"
      :aria-label="option"
      class="w-10 h-10 p-0 shrink-0 rounded-full border-2 border-solid outline-none flex items-center justify-center"
      :class="modelValue === option ? 'border-n-brand' : 'border-transparent'"
      @click="emit('update:modelValue', option)"
    >
      <span class="w-8 h-8 rounded-full" :style="{ backgroundColor: option }" />
    </button>
  </div>
</template>
